import { site } from "../content";
import { trackEvent } from "./analytics";

// Abre a conversa no WhatsApp com o campo de mensagem vazio (sem texto pré-preenchido).
export const waLink = () => `https://wa.me/${site.whatsappNumber}`;

export const trackWhatsAppClick = (location, text) => {
  trackEvent("whatsapp_click", {
    cta_location: location,
    cta_text: text,
    page_path: window.location.pathname,
  });
};
